import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  className = '',
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-stone-700 mb-1">
          {label}
        </label>
      )}

      <input
        className={`
          w-full px-3 py-2 lg:py-3 border rounded-xl shadow-sm transition-colors min-h-[48px]
          focus:outline-none focus:ring-2 focus:ring-rose-500 focus:border-rose-500 lg:text-base
          ${error ? 'border-rose-500 focus:ring-rose-500 focus:border-rose-500' : 'border-stone-200'}
          ${className}
        `}
        {...props}
      />

      {error && (
        <p className="mt-1 text-sm text-rose-600">{error}</p>
      )}

      {helperText && !error && (
        <p className="mt-1 text-sm text-stone-500">{helperText}</p>
      )}
    </div>
  );
};

export default Input;